import { Images } from '@/assets/images';
import { DocTypeEnum, REGEX } from '@/constant';
import { cn } from '@/utils';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	numberOfTime: '',
	applicantName: '',
	applicantBirthDate: '',
	applicantAddress: '',
	applicantPhone: '',
	height: '',
	weight: '',
	bloodPressure: '',
	leftEye: '',
	rightEye: '',
	colorBlindness: '',
	leftEar: '',
	rightEar: '',
	philopon: '',
	cocain: '',
	opium: '',
	hemp: '',
	etc: '',
	testDate: '',
	doctorSignature: '',
	result: '',
	reason: '',
	opinion: '',
	checkDetails: '',
	registerDate: '',
	headOfAgencySignature: '',
	avatar: '',
};

type IValues = typeof initializeValue;

export const MINISTRY_OF_JUSTICE_PUBLIC_HEALTH_CONFIG: FormConfig<
	IValues,
	DocTypeEnum.AFR_05
> = {
	initializeValue,
	title: '보건소 및 보건의료원 발급 서식',
	mapPropToValues({
		refTableName,
		applicantData,
		lodgingData,
		applicantLodgingData,
	}) {
		return {
			...initializeValue,
			applicantName: applicantData?.fullName || '',
			applicantBirthDate: applicantData?.birthDate || '',
			applicantPhone: applicantData?.phone || '',
			avatar: applicantData?.avatarFile || '',
			applicantAddress: lodgingData?.address
				? lodgingData?.address
				: applicantLodgingData?.lodgingAddress || '',
		};
	},
	pages: [
		{
			background: {
				src: Images.formPublicHealthCentersHighlight,
				className: 'template',
				dataSource: Images.formPublicHealthCenters,
			},

			textAreas: [
				{
					name: 'numberOfTime',
					maxHeight: 20,
					maxLength: 10,
					containerClassName: 'absolute top-[223px] left-[97px] w-[85px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'applicantName',
					maxHeight: 41,
					maxLength: 50,
					containerClassName: 'absolute top-[248px] left-[182px] w-[143px]',
					regex: REGEX.ALLOW_KR_EN,
				},
				{
					name: 'applicantAddress',
					maxHeight: 60,
					maxLength: 45,
					containerClassName: 'absolute top-[290px] left-[181px] w-[145px]',
				},
				{
					name: 'applicantPhone',
					maxHeight: 60,
					maxLength: 18,
					containerClassName: 'absolute top-[290px] left-[454px] w-[120px]',
					regex: REGEX.ALLOW_PHONE_NUMBER,
				},
				{
					name: 'height',
					maxHeight: 18,
					maxLength: 3,
					containerClassName: 'absolute top-[416px] left-[174px] w-[70px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
					className: 'text-right',
				},
				{
					name: 'weight',
					maxHeight: 18,
					maxLength: 3,
					containerClassName: 'absolute top-[415px] left-[377px] w-[50px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'bloodPressure',
					maxHeight: 20,
					maxLength: 3,
					containerClassName: 'absolute top-[415px] left-[568px] w-[120px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'leftEye',
					maxHeight: 20,
					maxLength: 3,
					containerClassName: 'absolute top-[452px] left-[223px] w-[28px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'rightEye',
					maxHeight: 20,
					maxLength: 3,
					containerClassName: 'absolute top-[483px] left-[228px] w-[28px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'colorBlindness',
					maxHeight: 60,
					maxLength: 20,
					containerClassName: 'absolute top-[446px] left-[370px] w-[83px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'leftEar',
					maxHeight: 20,
					maxLength: 3,
					containerClassName: 'absolute top-[452px] left-[633px] w-[28px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'rightEar',
					maxHeight: 20,
					maxLength: 3,
					containerClassName: 'absolute top-[483px] left-[633px] w-[28px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'philopon',
					maxHeight: 36,
					maxLength: 10,
					containerClassName: 'absolute top-[541px] left-[140px] w-[60px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					className: 'h-9',
				},
				{
					name: 'cocain',
					maxHeight: 36,
					maxLength: 10,
					containerClassName: 'absolute top-[541px] left-[265px] w-[60px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					className: 'h-9',
				},
				{
					name: 'opium',
					maxHeight: 36,
					maxLength: 10,
					containerClassName: 'absolute top-[541px] left-[380px] w-[60px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					className: 'h-9',
				},
				{
					name: 'hemp',
					maxHeight: 36,
					maxLength: 10,
					containerClassName: 'absolute top-[541px] left-[496px] w-[60px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					className: 'h-9',
				},
				{
					name: 'etc',
					maxHeight: 36,
					maxLength: 10,
					containerClassName: 'absolute top-[541px] left-[610px] w-[70px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					className: 'h-9',
				},
				{
					name: 'doctorSignature',
					maxHeight: 20,
					maxLength: 12,
					containerClassName: 'absolute top-[663px] left-[532px] w-[112px]',
				},
				(values, index) => ({
					name: 'reason',
					maxHeight: 31,
					maxLength: 100,
					className: 'h-[31px]',
					containerClassName: cn('absolute top-[725px] left-[341px] w-[360px]'),
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					onKeyDown: (e) => {
						if (e.key === 'Tab' || e.key === 'Enter') {
							e.preventDefault();
						}
					},
					disabled: values?.result !== '불량',
				}),
				{
					name: 'opinion',
					maxHeight: 52,
					maxLength: 100,
					containerClassName: 'absolute top-[760px] left-[204px] w-[500px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					className: 'h-[52px]',
				},
				(values, index) => ({
					name: 'checkDetails',
					maxHeight: 48,
					maxLength: 100,
					className: 'text-[14px] text-left focus:bg-white !h-[48px]',
					containerClassName: cn(
						'absolute top-[817px] left-[204px] w-[500px]',
						values?.checkDetails && 'bg-white'
					),
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					onKeyDown: (e) => {
						if (e.key === 'Tab' || e.key === 'Enter') {
							e.preventDefault();
						}
					},
				}),
				{
					name: 'headOfAgencySignature',
					maxHeight: 20,
					maxLength: 12,
					containerClassName: 'absolute bottom-[142px] right-[154px] w-[127px]',
				},
			],
			checkboxes: [
				{
					name: 'result',
					classNames: [
						'absolute top-[700px] left-[266px] w-[12px] h-[12px]',
						'absolute top-[700px] right-[410px] w-[12px] h-[12px]',
					],
					options: ['양호', '불량'],
					getResetKey: () => ['reason'],
					iconType: 'square',
				},
			],
			datePickers: [
				{
					name: 'applicantBirthDate',
					className: '[&>.ant-picker-input>input]:!text-[14px]',
					containerClassName: 'absolute top-[258px] left-[460px] w-[120px]',
					format: 'YYYY-MM-DD',
				},
				{
					name: 'testDate',
					segmentedInputs: true,
					containerClassName: 'absolute top-[634px] left-[502px] w-[160px]',
					format: 'YYYY          MM           DD',
					style: { fontSize: '14px' },
					boxStyle: { marginBottom: '-17px' },
				},
				{
					name: 'registerDate',
					segmentedInputs: true,
					containerClassName: 'absolute bottom-[210px] left-[506px] w-[168px]',
					format: 'YYYY          MM           DD',
					style: { fontSize: '14px' },
					boxStyle: { marginBottom: '-17px' },
				},
			],
			inputFiles: [
				{
					name: 'avatar',
					className: 'absolute top-[198px] left-[578px] w-[128px] h-[154px]',
				},
			],
		},
	],
};
